import React, { useEffect, useState } from 'react'
import { Button, Checkbox, Divider, Drawer, Flex, Tag } from 'antd'

import moment from 'moment'
import useThrottle from '../../../../../hook/useThrottle';
import { editPermissionCustomer, IGroupPermissionCustomerEdit } from '../../../../../api/groupPermission/groupPermissionApi';
const CheckboxGroup = Checkbox.Group;
interface Props {
  show: boolean
  groupPermissionId: number
  infoPermissionCustomer: IGroupPermissionCustomerEdit[]
  onClose: () => void
  resultFormSubmit?: (iSsuccess: boolean, message?: string) => void;
}

const dataDefaultField = [
  {
    name: 'Mã định danh khách hàng',
    key: 'code',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Họ và tên',
    key: 'username',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Giới tính',
    key: 'gender',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'CCCD',
    key: 'CCCD',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Số điện thoại - Nhà',
    key: 'phoneHome',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Số điện thoại - Công ty',
    key: 'phoneCompany',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Sở thích',
    key: 'hobby',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Nghề nghiệp',
    key: 'profession',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Ngày sinh',
    key: 'birthday',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Mail',
    key: 'email',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Tỉnh/thành phố',
    key: 'province',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Quận/huyện',
    key: 'district',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Địa chỉ',
    key: 'address',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Tên doanh nghiệp',
    key: 'businessName',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Mã số thuế',
    key: 'taxCode',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Ngày thành lập',
    key: 'foundingDate',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Tình trạng hôn nhân',
    key: 'statusMarital',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Quan hệ doanh nghiệp',
    key: 'businessRelationship',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Nhóm khách hàng',
    key: 'groupCustomer',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Mô tả khách hàng',
    key: 'description',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Ảnh đại diện',
    key: 'image',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Thuộc',
    key: 'affiliated',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Nguồn',
    key: 'sourceCustomer',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Nhân viên chăm sóc',
    key: 'careStaff',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Lĩnh vực kinh doanh',
    key: 'businessFieldId',
    isEdit: false,
    isView: false,
    allow: []
  },
  {
    name: 'Đơn vị',
    key: 'unit',
    isEdit: false,
    isView: false,
    allow: []
  }
];

const DrawerDataFieldEdit: React.FC<Props> = ({
  show, groupPermissionId, infoPermissionCustomer,
  onClose, resultFormSubmit
}) => {

  const [isCheckAlldataField, setIsCheckAlldataField] = useState(false)
  const [dataField, setDataField] = useState<{ key: string; name: string; isEdit: boolean; isView: boolean; allow: string[] }[]>(dataDefaultField
  )


  const onChangeAllDataField = (value: boolean) => {
    setIsCheckAlldataField(value);

    setDataField(prev =>
      prev.map(field => ({
        ...field,
        allow: value ? ["Xem", "Sửa"] : [],
        isEdit: value,
        isView: value
      }))
    );
  }

  const onChangeDataField = (key: string, value: string[]) => {
    const updatedData = dataField.map(field =>
      field.key === key ? {
        ...field, allow: value, isEdit: value.includes("Sửa"),
        isView: value.includes("Xem")
      } : field
    );
    setDataField(updatedData);
  }

  const onFinish = useThrottle(async () => {
    const dataIsEditMap = dataField.reduce((acc, field) => {
      acc[field.key] = field.isEdit;
      return acc;
    }, {} as Record<string, boolean>);
    (dataIsEditMap as any).actions = 2;
    // (dataIsEditMap as any).permissionCustomerId = infoPermissionCustomer.find(item => item.actions === 2)?.groupPermissionId;
    (dataIsEditMap as any).permissionCustomerId = infoPermissionCustomer.find(item => item.actions === 2)?.id;

    const dataIsViewMap = dataField.reduce((acc, field) => {
      acc[field.key] = field.isView;
      return acc;
    }, {} as Record<string, boolean>);
    //actions 1 là view
    (dataIsViewMap as any).actions = 1;
    // (dataIsViewMap as any).permissionCustomerId = infoPermissionCustomer.find(item => item.actions === 1)?.groupPermissionId;
    (dataIsViewMap as any).permissionCustomerId = infoPermissionCustomer.find(item => item.actions === 1)?.id;

    const result = await editPermissionCustomer(groupPermissionId, [dataIsViewMap], [dataIsEditMap])
    if (result?.status) {
      resultFormSubmit?.(true, result?.message)
    } else {
      resultFormSubmit?.(false, result?.message)
    }
  }, 2000)


  useEffect(() => {
    const allChecked = dataField.every(field => field.allow.length === 2);
    setIsCheckAlldataField(allChecked);
  }, [dataField])

  useEffect(() => {
    if (show) {
      const dataView = infoPermissionCustomer.find(item => item.actions === 1);
      const dataEdit = infoPermissionCustomer.find(item => item.actions === 2);
      if (dataView && dataEdit) {
        const updatedDataField = dataDefaultField.map(field => {
          const isView = !!dataView[field.key as keyof IGroupPermissionCustomerEdit];
          const isEdit = !!dataEdit[field.key as keyof IGroupPermissionCustomerEdit];

          return {
            ...field,
            isView,
            isEdit,
            allow: isView && isEdit ? ["Xem", "Sửa"] : isView ? ["Xem"] : isEdit ? ["Sửa"] : []
          };
        });

        setDataField(updatedDataField)
      }
    } else {
      setIsCheckAlldataField(false);
      setDataField(dataDefaultField);
    }
  }, [show])

  return (
    <Drawer
      open={show}
      title={
        <div className='d-flex justify-between w-full'>
          <span className='text-base fw-500'>Trường dữ liệu</span>
          <button
            className='border-none bg-1890FF rounded-6-px text-white w-56-px h-8'
            onClick={onFinish}
          >Lưu</button>
        </div>
      }
      className='rs-drawer'
      closeIcon={false}
      footer={false}
      onClose={onClose}
    >
      <div className='d-flex flex-column gap-3'>
        <div className='d-flex flex-column'>
          <span className='text-sm fw-700 '>Trường dữ liệu của khách hàng</span>
          <span className='text-sm fw-400 text-98A2B3'>Cấp quyền cho phép xem và chỉnh sửa các trường này</span>
        </div>
        <div className='d-flex flex-column gap-3'>
          <Checkbox
            className="size-check-box size-check-box-inner p-checkbox icon-check-box"
            checked={isCheckAlldataField}
            onChange={(e) => onChangeAllDataField(e.target.checked)}
          >
            <span className='text-base font-regular'>Chọn tất cả</span>

          </Checkbox>
          <div className='d-flex flex-column gap-6'>
            {
              dataField.map((item, index) => (
                <div
                  key={index}
                  className='d-flex justify-between'
                >
                  <span className='text-sm fw-400 font-regular'>{item.name}</span>
                  <CheckboxGroup
                    options={["Xem", "Sửa"]}
                    value={item.allow}
                    onChange={(selected) => onChangeDataField(item.key, selected)}
                  />
                </div>
              ))
            }

          </div>
        </div>

      </div>
    </Drawer>
  )
}

export default DrawerDataFieldEdit
